<div class="instructor-section">
  @if(user){
  <div class="flex items-start gap-6">
    <!-- Instructor Avatar -->
    <div class="flex-shrink-0">
      @if(user.profile.personal.avatar?.path){
      <div class="w-24 h-24 rounded-full overflow-hidden ring-4 ring-base-200 shadow-lg">
        <img
          width="96"
          height="96"
          [src]="user.profile.personal.avatar?.path"
          alt="{{ getUserName() }}"
          class="w-full h-full object-cover"
        />
      </div>
      }@else {
      <div class="w-24 h-24 rounded-full bg-primary/10 flex items-center justify-center ring-4 ring-base-200 shadow-lg">
        <span class="text-3xl font-bold text-primary">{{ getUserName().charAt(0) }}</span>
      </div>
      }
    </div>
    
    <!-- Instructor Info -->
    <div class="flex-1">
      <div class="flex items-center gap-2 mb-2">
        <i class="fa-solid fa-graduation-cap text-primary text-base"></i>
        <span class="text-sm font-semibold text-primary uppercase tracking-wide">Instructor</span>
      </div>
      <h3 class="text-2xl font-bold text-base-content mb-3">{{ getUserName() }}</h3>
      <div
        class="text-base text-base-content/80 leading-relaxed prose prose-neutral max-w-none"
        [innerHTML]="user.profile.personal.biography"
      ></div>
    </div>
  </div>
  }@else {
  <div class="flex items-center gap-3 text-base-content/60">
    <span class="daisy-loading daisy-loading-spinner daisy-loading-md"></span>
    <span>Loading instructor information...</span>
  </div>
  }
</div>
